import { useQuery } from "@tanstack/react-query"
import { knowledgeBaseQuery } from "../lib/knowledgeBaseQuery"

export function useKnowledgeBaseQuery(...args: Parameters<typeof knowledgeBaseQuery>) {
  return useQuery(knowledgeBaseQuery(...args))
}
